"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecuteDatalakeHydrationEventJobPayloadStruct = exports.ALL_DATALAKE_CREATE_OR_UPDATE_PARTITION_EVENTS = exports.AthenaQueryResultTypeIterable = exports.AthenaTablePropertyType = exports.AwsGlueColumnTypeStruct = exports.QuicksightEmbeddingErrorCodes = exports.QuicksightEmbedType = exports.TransformationOp = exports.LIMITED_PARTNERS_ENTITY_CREDIT_FACILITY_SLUG_PARTITION_TABLES = exports.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME = exports.NAMED_RDFV_PARTITION_TABLES = exports.REPORTING_DATE_FILE_VERSION_PARTITION_TABLES = exports.LOAN_PRODUCT_AND_CREDIT_FACILITY_DATALAKE_TABLE_NAME = exports.ONLY_CREDIT_FACILITY_DATALAKE_TABLE_NAME = exports.ONLY_LOAN_PRODUCT_DATALAKE_TABLE_NAME = exports.ALL_CREDIT_FACILITY_TABLE_PREFIXES = exports.ALL_TABLE_PREFIXES = exports.MANAGED_BY_DATALAKE_TABLES = exports.CUSTOM_TAPES_PREFIXES = exports.CUSTOM_TAPES_LATEST_PREFIX = exports.CUSTOM_TAPES_PREFIX = exports.ATHENA_VIEW_PREFIXES = exports.ATHENA_VIEWS_ORG_SUFFIXED = exports.PORTFOLIO_COVENANTS_LENDER_ATHENA_VIEW_PREFIX = exports.FINANCIAL_COVENANTS_LENDER_ATHENA_VIEW_PREFIX = exports.FIN_STATEMENTS_LENDER_ATHENA_VIEW_PREFIX = exports.FUNDING_REQUEST_BORROWER_ATHENA_VIEW_PREFIX = exports.ACCOUNTING_BORROWER_ATHENA_VIEW_PREFIX = exports.PORTFOLIO_BBR_LENDER_ATHENA_VIEW_PREFIX = exports.LIMITED_PARTNERS_ATHENA_VIEW_PREFIXES = exports.ORG_PROVIDED_INPUT_VALUES_VIEW_PREFIX = exports.ATTRIBUTES_ATHENA_VIEW_PREFIX = exports.QuickSightDataType = void 0;
const zod_1 = require("zod");
var QuickSightDataType;
(function (QuickSightDataType) {
    // *** Credit Facility Specific ***
    QuickSightDataType["MasterLoanTape"] = "masterLoanTape";
    QuickSightDataType["AssignedLoanTape"] = "assignedLoanTape";
    QuickSightDataType["ReceivableResponseTape"] = "receivableResponseTape";
    // *** Portfolio View ***
    QuickSightDataType["PortfolioReceivableResponseTape"] = "portfolioReceivableResponseTape";
})(QuickSightDataType || (exports.QuickSightDataType = QuickSightDataType = {}));
/**
 * Athena table and view prefixes available in the datalake
 * Party Permissions
 * - borrowers: all tables
 * - capProviders: only credit facility scoped tables
 */
exports.ATTRIBUTES_ATHENA_VIEW_PREFIX = 'attributes';
exports.ORG_PROVIDED_INPUT_VALUES_VIEW_PREFIX = 'org_provided_input_values';
exports.LIMITED_PARTNERS_ATHENA_VIEW_PREFIXES = [
    'limited_partner_mappings',
    'limited_partners',
];
exports.PORTFOLIO_BBR_LENDER_ATHENA_VIEW_PREFIX = 'portfolio_bbr_lender';
exports.ACCOUNTING_BORROWER_ATHENA_VIEW_PREFIX = 'accounting_borrower';
exports.FUNDING_REQUEST_BORROWER_ATHENA_VIEW_PREFIX = 'funding_request_borrower';
exports.FIN_STATEMENTS_LENDER_ATHENA_VIEW_PREFIX = 'fin_statements_lender';
exports.FINANCIAL_COVENANTS_LENDER_ATHENA_VIEW_PREFIX = 'financial_covenants_lender';
exports.PORTFOLIO_COVENANTS_LENDER_ATHENA_VIEW_PREFIX = 'portfolio_covenants_lender';
exports.ATHENA_VIEWS_ORG_SUFFIXED = [
    ...exports.LIMITED_PARTNERS_ATHENA_VIEW_PREFIXES,
    exports.ATTRIBUTES_ATHENA_VIEW_PREFIX,
    exports.PORTFOLIO_BBR_LENDER_ATHENA_VIEW_PREFIX,
    exports.ORG_PROVIDED_INPUT_VALUES_VIEW_PREFIX,
    exports.ACCOUNTING_BORROWER_ATHENA_VIEW_PREFIX,
    exports.FUNDING_REQUEST_BORROWER_ATHENA_VIEW_PREFIX,
    exports.FIN_STATEMENTS_LENDER_ATHENA_VIEW_PREFIX,
    exports.FINANCIAL_COVENANTS_LENDER_ATHENA_VIEW_PREFIX,
    exports.PORTFOLIO_COVENANTS_LENDER_ATHENA_VIEW_PREFIX,
];
exports.ATHENA_VIEW_PREFIXES = exports.ATHENA_VIEWS_ORG_SUFFIXED;
// custom_tapes: tape created from tape-builder/BBPL configuration
exports.CUSTOM_TAPES_PREFIX = 'custom_tapes';
exports.CUSTOM_TAPES_LATEST_PREFIX = 'custom_tapes_latest';
exports.CUSTOM_TAPES_PREFIXES = [
    exports.CUSTOM_TAPES_PREFIX,
    exports.CUSTOM_TAPES_LATEST_PREFIX,
];
exports.MANAGED_BY_DATALAKE_TABLES = [
    exports.CUSTOM_TAPES_PREFIX,
    exports.CUSTOM_TAPES_LATEST_PREFIX,
];
exports.ALL_TABLE_PREFIXES = [
    'cash_response_tapes',
    'cash_response_tapes_latest',
    'covenant_loan_tapes',
    'covenant_loan_tapes_latest',
    'internal_repayment_tapes',
    'internal_repayment_tapes_latest',
    'master_loan_tapes',
    'master_loan_tapes_latest',
    'assigned_loan_tapes',
    'assigned_loan_tapes_latest',
    'assigned_repayment_tapes',
    'assigned_repayment_tapes_latest',
    'borrowing_base_report',
    'borrowing_base_report_latest',
    'receivable_response_tapes',
    'receivable_response_tapes_latest',
    'limited_partner_tapes',
    'limited_partner_tapes_latest',
    'financial_statements',
    'financial_statements_latest',
    ...exports.ATHENA_VIEW_PREFIXES,
    ...exports.MANAGED_BY_DATALAKE_TABLES,
];
exports.ALL_CREDIT_FACILITY_TABLE_PREFIXES = [
    'assigned_loan_tapes',
    'assigned_loan_tapes_latest',
    'assigned_repayment_tapes',
    'assigned_repayment_tapes_latest',
    'borrowing_base_report',
    'borrowing_base_report_latest',
    'cash_response_tapes',
    'cash_response_tapes_latest',
    'receivable_response_tapes',
    'receivable_response_tapes_latest',
];
/**
 * *** DATALAKE TABLE NAME STRUCTURE CATEGORIES ***
 *
 * For each of our Datalake tables, we prefix them with a set of options (above)
 * and each of them have a defined construct of how the table name is generated,
 * whether it includes LP slug, CF slug, or both.
 * Will need to monitor and update accordingly as we add more tables / variations
 */
exports.ONLY_LOAN_PRODUCT_DATALAKE_TABLE_NAME = [
    'internal_repayment_tapes',
    'internal_repayment_tapes_latest',
    'master_loan_tapes',
    'master_loan_tapes_latest',
];
exports.ONLY_CREDIT_FACILITY_DATALAKE_TABLE_NAME = [
    'borrowing_base_report',
    'borrowing_base_report_latest',
    'cash_response_tapes',
    'cash_response_tapes_latest',
    'receivable_response_tapes',
    'receivable_response_tapes_latest',
];
exports.LOAN_PRODUCT_AND_CREDIT_FACILITY_DATALAKE_TABLE_NAME = [
    'assigned_loan_tapes',
    'assigned_loan_tapes_latest',
    'assigned_repayment_tapes',
    'assigned_repayment_tapes_latest',
    'covenant_loan_tapes',
    'covenant_loan_tapes_latest',
];
// tables partitioned by reporting date / file version
exports.REPORTING_DATE_FILE_VERSION_PARTITION_TABLES = [
    'cash_response_tapes',
    'cash_response_tapes_latest',
    'covenant_loan_tapes',
    'covenant_loan_tapes_latest',
    'internal_repayment_tapes',
    'internal_repayment_tapes_latest',
    'master_loan_tapes',
    'master_loan_tapes_latest',
    'assigned_loan_tapes',
    'assigned_loan_tapes_latest',
    'assigned_repayment_tapes',
    'assigned_repayment_tapes_latest',
    'borrowing_base_report',
    'borrowing_base_report_latest',
    'receivable_response_tapes',
    'receivable_response_tapes_latest',
];
// tables with properly named "partitions" in the format of
// prefix/reportingdate=YYYY-MM-DD/fileversion=N/suffix (which automatically become columns in the datalake table)
// this is different than REPORTING_DATE_FILE_VERSION_PARTITION_TABLES which are just prefix/YYYY-MM-DD/N/suffix
exports.NAMED_RDFV_PARTITION_TABLES = [
    'custom_tapes',
    'custom_tapes_latest',
];
// tables partitions by fin statement, period, reporting date, version (file version)
exports.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME = [
    'financial_statements',
    'financial_statements_latest',
];
// tables partitions by creditFacility, reporting date, version (file version)
exports.LIMITED_PARTNERS_ENTITY_CREDIT_FACILITY_SLUG_PARTITION_TABLES = [
    'limited_partner_tapes',
    'limited_partner_tapes_latest',
];
var TransformationOp;
(function (TransformationOp) {
    TransformationOp["AttachMetadata"] = "op_attach_metadata";
    TransformationOp["CastNumberFieldsAsDouble"] = "op_cast_number_fields_as_double";
    TransformationOp["Unnest"] = "op_unnest";
    TransformationOp["ResolveChoice"] = "op_resolve_choice";
    TransformationOp["ShortenColumnNames"] = "op_shorten_column_names";
    TransformationOp["WriteParquetToCurated"] = "op_write_parquet_to_curated";
    TransformationOp["NoOp"] = "op_none";
})(TransformationOp || (exports.TransformationOp = TransformationOp = {}));
var QuicksightEmbedType;
(function (QuicksightEmbedType) {
    QuicksightEmbedType[QuicksightEmbedType["Dashboard"] = 0] = "Dashboard";
    QuicksightEmbedType[QuicksightEmbedType["Console"] = 1] = "Console";
})(QuicksightEmbedType || (exports.QuicksightEmbedType = QuicksightEmbedType = {}));
var QuicksightEmbeddingErrorCodes;
(function (QuicksightEmbeddingErrorCodes) {
    QuicksightEmbeddingErrorCodes["DashboardIsNotConfiguredForQuicksight"] = "DashboardIsNotConfiguredForQuicksight";
    QuicksightEmbeddingErrorCodes["UserIsNotConfiguredForQuicksight"] = "UserIsNotConfiguredForQuicksight";
})(QuicksightEmbeddingErrorCodes || (exports.QuicksightEmbeddingErrorCodes = QuicksightEmbeddingErrorCodes = {}));
// Athena data types
// https://docs.aws.amazon.com/athena/latest/ug/data-types.html
//
// NOTE: glue job data type differ from athena data types
// https://docs.aws.amazon.com/glue/latest/dg/aws-glue-programming-etl-connect.html
exports.AwsGlueColumnTypeStruct = zod_1.z.enum([
    'date',
    'string',
    'boolean',
    'double',
]);
var AthenaTablePropertyType;
(function (AthenaTablePropertyType) {
    AthenaTablePropertyType["Boolean"] = "boolean";
    AthenaTablePropertyType["TinyInt"] = "tinyint";
    AthenaTablePropertyType["SmallInt"] = "smallint";
    AthenaTablePropertyType["Int"] = "int";
    AthenaTablePropertyType["Integer"] = "integer";
    AthenaTablePropertyType["BigInt"] = "bigint";
    AthenaTablePropertyType["Double"] = "double";
    AthenaTablePropertyType["Float"] = "float";
    AthenaTablePropertyType["Decimal"] = "decimal";
    AthenaTablePropertyType["Char"] = "char";
    AthenaTablePropertyType["Varchar"] = "varchar";
    AthenaTablePropertyType["String"] = "string";
    AthenaTablePropertyType["Binary"] = "binary";
    AthenaTablePropertyType["Date"] = "date";
    AthenaTablePropertyType["Timestamp"] = "timestamp";
    AthenaTablePropertyType["Array"] = "array";
    AthenaTablePropertyType["Map"] = "map";
    AthenaTablePropertyType["Struct"] = "struct";
})(AthenaTablePropertyType || (exports.AthenaTablePropertyType = AthenaTablePropertyType = {}));
/**
 * These types are purely meant for Athena query results, where we can't
 * just rely on the Athena table schema (as SQL operations can alter types).
 * If possible, should use Athena table schema itself as it's more definitive
 */
exports.AthenaQueryResultTypeIterable = [
    'number',
    'string',
    'boolean',
];
// most often consumer should use this if interested in listening for specific partition hydration event
exports.ALL_DATALAKE_CREATE_OR_UPDATE_PARTITION_EVENTS = [
    'CreatePartition',
    'BatchCreatePartition',
    'UpdatePartition',
    'BatchUpdatePartition',
];
// when a caller enqueues a job, they can pass a flag to execute the job immediately if
// if the partition already exists in the data catalog
// this is particularly useful in BBPL when a different portion of the graph executes prior to waitForDatalake node enqueues the job
exports.ExecuteDatalakeHydrationEventJobPayloadStruct = zod_1.z.object({
    datalakeHydrationEventJobId: zod_1.z.string(),
});
//# sourceMappingURL=DataLake.js.map